module.exports = __webpack_public_path__ + "static/media/Agri- Business infographics - Desktop - 12-06-2024 C.fcb8c71c.gif";